import React from 'react';
import { AdminDrawer } from '../admin/AdminDrawer';
import { AssistantEditDialog, type AssistantEditDialogProps } from './AssistantEditDialog';

export type AdminWorkspaceProps = {
  adminOpen: boolean;
  adminDrawerProps: React.ComponentProps<typeof AdminDrawer>;
  assistantEditDialogProps: AssistantEditDialogProps;
};

export function AdminWorkspace({ adminOpen, adminDrawerProps, assistantEditDialogProps }: AdminWorkspaceProps) {
  return (
    <>
      {adminOpen && (
        <AdminDrawer {...adminDrawerProps} />
      )}
      <AssistantEditDialog {...assistantEditDialogProps} />
    </>
  );
}
